import { AllLaunchDarklyFlags } from 'utils/launchdarkly/flags';

// these defaults were retrieved from launchdarkly PROD mobile on 3/30/2023
// the should only be used if all else fails (LD call fails and nothing is cached)
// The below type enforces that when we add a flag a default is set

const safeFlagDefaults: AllLaunchDarklyFlags = {
  // TODO: these flags below should be removed from LD, they do not appear to be used by our codebase anymore
  // 'enable-react-native-fulfillment-service-get-user-orders': true,
  // 'chef-recommendation-engine-2': 'SANITY',
  // chefUpsellItemCount: 2,
  // 'deprecate-chef': true,
  // 'show-loyalty-banner-v2': false,
  // 'enable-react-native-fulfillment-service-commit-order': true,
  // 'show-loyalty-banner-v2-in-home': false,
  // 'enable-react-native-fulfillment-service-price-order': true,
  // 'enable-react-native-fulfillment-service-get-order': true,
  // 'enable-signout-on-invalid-token': false,

  // TODO: these flags aren't returned by LD  but required by the enum
  // should we remove or is it part of payments refactor maybe?
  'enable-paypal-payments': undefined,
  'enable-tracking-GTM': false,
  'enable-vault-after-making-one-time-payment': undefined,
  'enable-test-apple-pay-web': undefined,
  'enable-test-google-pay-web': undefined,

  'tiered-catering-delivery-fees': {},
  'show-ordering-issue-info': true,
  'show-increased-delivery-fees-modal': false,
  'enable-menu-service-data': true,
  'enable-consolidated-delivery-restaurant-backend-logic': true,
  'enable-ccpa-do-not-sell-button': false,
  enableUserSavedDeliveryAddressPhone: true,
  enableGuestAndMultiStepSupportForm: true,
  tipPercentThresholdCents: 1500,
  displayNutritionWithModifiersFromSanity: false,
  'hide-ui-calories': false,
  enableFavoriteStores: true,
  'enable-favorites-display-calories': false,
  enableSignUp: true,
  enableRadarTrackingOnNewSessions: false,
  enableOrderTimedFire: false,
  'send-postal-code-only-for-first-data-payment': false,
  enableDeliveryCancellationPolicy: true,
  enableRecentlyOrderedItems: true,
  'enable-loyalty-surprise-offers': true,
  'enable-unverified-saved-payments': true,
  enableOffers: true,
  'enable-cash-payment': false,
  'skip-loyalty-store-validation': false,
  enableNewServiceModeFlow: false,
  'loyalty-link-card-reward-timeout': 8760,
  'enable-delivery-checkout-outside-opening-hours': false,
  enableApplePay: true,
  enableNewPhoneNumberField: false,
  'enable-rpos-order-timed-fire': true,
  'enable-checkout-upsell-items-2': true,
  'enable-meter-on-rewards': true,
  'enable-new-payments-frontend': false,
  'enable-react-native-navigation': false,
  enableAutoSelectRestaurant: true,
  enableOrderTimedFireNCR: true,
  'enable-sort-offers-for-service-mode': true,
  'enable-delivery-details-form-require-address-2': false,
  enableOrderTimedFireQST: false,
  'enable-top-service-mode': true,
  'enable-hamburger-menu-on-mobile': true,
  enableInternalDiagnosticTools: false,
  disableDriveThru: false,
  'enable-tabbed-menu-bar': true,
  'use-high-volume-support-msg': false,
  'enable-timed-fire-for-drive-thru': false,
  enableOffersRefresh: true,
  disableTakeOut: false,
  enableCommunicationPreferences: false,
  'enable-feature-onboarding': false,
  'enable-loyalty-offers-filters': false,
  CheckoutCateringLimitOverrideCents: 0,
  'enable-product-image-disclaimer': false,
  'force-homepage-auth': false,
  checkoutCateringMinimumOverrideCents: 0,
  autoFillTestCard: false,
  enableOrdering: true,
  'enable-offer-qr-code': false,
  'enable-th-scan-and-pay': false,
  'hide-tip-amount-checkout': false,
  CheckoutLimitOverrideCents: 10000,
  'enable-alpha-beta-store-ordering': false,
  'enable-reward-page-stand-alone': false,
  'order-locator-tabs': { '0': 'nearby', '1': 'favorite', '2': 'recent' },
  enableDiagnosticTools: true,
  'enable-find-restaurant-link': true,
  'enable-loyalty-fe': true,
  'enable-html-in-app-messages-in-braze-sdk': true,
  'enable-native-mobile-account': true,
  'enable-nutrition-explorer-allergens': false,
  enablePromoCodeAtCheckout: false,
  'enable-add-extras': true,
  enableOrderTimedFireCarrols: false,
  'enable-zero-bounce-error-modal': true,
  'enable-locator-clear-store-and-sm-button': false,
  'enable-customer-can-edit-own-phone-number': true,
  enableFormattedCaloriesForDefault: true,
  'enable-my-code-new-ui': false,
  'reset-cart-timeout-hrs': 48,
  enableOffersMobile: true,
  enableAutoSignInOnSignUp: true,
  'send-same-otp-code-once': true,
  'temp-enable-carousel-component-update': false,
  datadogRumSampleRate: 1,
  enableHideOffersForServiceMode: false,
  'tiered-delivery-fees': {
    '0': {
      googleFoodOrdering: { fee: 100, discount: 0, smallCartFee: 250, serviceFeePercent: 15 },
      app: { discount: 0, serviceFeePercent: 15, smallCartFee: 250, fee: 100 },
      web: { discount: 0, fee: 100, smallCartFee: 250, serviceFeePercent: 15 },
      kiosk: { discount: 0, fee: 0, serviceFeePercent: 0, smallCartFee: 0 },
    },
    '1000': {
      app: { fee: 100, discount: 0, smallCartFee: 0, serviceFeePercent: 15 },
      web: { fee: 100, discount: 0, smallCartFee: 0, serviceFeePercent: 15 },
      kiosk: { discount: 0, fee: 0, serviceFeePercent: 0, smallCartFee: 0 },
      googleFoodOrdering: { discount: 0, fee: 100, serviceFeePercent: 15, smallCartFee: 0 },
    },
  },
  'show-loyalty-banner-v1': true,
  'enable-calories-calculator': true,
  'fe-personalized-offers-template': true,
  'enable-delivery-only': false,
  enableOrderTimedFireSICOM: true,
  'enable-hide-store-modal-order-here-button': false,
  enableNutritionDecimals: false,
  'enable-future-ordering': false,
  enableHideLoyaltyBannerWelcomeMessage: false,
  enableStoreConfirmationModal: true,
  'my-account-fields-variations': {
    zip: true,
    agreesToTermsOfService: true,
    dob: true,
    name: true,
    wantsPromotionalEmails: true,
    email: true,
    phone: true,
    country: false,
  },
  'enable-static-in-store-identification': false,
  'enable-loyalty-points-in-header': false,
  'enable-delivery-order-timed-fire': false,
  'ab-testing-home-page': 'feature-home-page-singleton',
  enableThDirectPayApplePay: false,
  'enable-payment-error-continue': false,
  'enable-link-physical-card': true,
  'supported-card-brands-variations': ['amex', 'diners', 'discover', 'jcb', 'mc', 'visa'],
  'enable-closing-time-dialog': false,
  'store-card-button-options': { '0': 'info', '1': 'order', '2': 'offers' },
  'enable-loyalty-promo-codes': true,
  'enable-favorites': true,
  'enable-one-trust-cookie-consent-banner': true,
  'enable-pypestream': true,
  'enable-clear-store-after-order': false,
  'enable-menu-service-plus-fe': true,
  'enable-one-time-password': 'Email',
  'enable-street-number-after-street-name': false,
  enableCateringDelivery: false,
  fireOrderAhead: 240,
  'enable-loyalty-standard-offers': true,
  'enable-switch-service-mode-modal': false,
  'enable-discounts-on-order-receipt': false,
  enableFeatureHomePage: true,
  'enable-store-selection-2': false,
  'enable-order-number-generation': false,
  'enable-rewards-static-page': false,
  enableDoubleVaultingFromPaymentMethods: false,
  'timed-fire-options': { generateOptions: null },
  'radius-for-store-locator': 32000,
  enableImCloseDisplay: false,
  'enable-global-offers-cooldown': true,
  'enable-mparticle-qr-code': false,
  enableDeliveryWatchDriverLocation: false,
  'th-direct-pay': false,
  enableServiceModeCartSelection: true,
  'enable-recent-items-in-menu': false,
  'enable-my-code-payment-method': false,
  'enable-new-menu-customization-design': true,
  'enable-user-not-found-mask-on-auth-flows': false,
  enableBottomServiceMode: false,
  enableAccountDeletePage: false,
  'enable-tabbed-menu-bar-recents': true,
  'enable-loyalty-qr-and-short-code': false,
  'hide-items-from-nutrition-info': {
    proteins: false,
    cholesterol: false,
    calories: false,
    saltPer100: false,
    energyKJPer100: false,
    saturatedFat: false,
    carbohydrates: false,
    sodium: false,
    fatPer100: false,
    caloriesPer100: false,
    sugarPer100: false,
    sugar: false,
    carbohydratesPer100: false,
    proteinsPer100: false,
    fat: false,
    salt: false,
    saturatedFatPer100: false,
    transFat: false,
    fiber: false,
    weight: true,
    energyKJ: false,
  },
  'enable-digital-wallet-migration': false,
  enableAccountDeleteOneTrust: true,
  enableNutritionExplorer: true,
  enableAccountDeleteOneTrustStaticPage: false,
  enableFreeDeliveryCheckoutProgressBar: false,
  enableOffersSelectRestaurantCta: true,
  'enable-app-issue-collector': false,
  'enable-reorder': true,
  'force-ota-app-update': 'none',
  'enable-account-region-verification': false,
  enableGooglePay: true,
  'enable-numeric-phone-validation': false,
  'enable-qr-code-in-my-code-page': false,
  'enable-qr-code-loyalty-id': false,
  'enable-amenities-section': false,
  'adyen-supported-card-brands-variations': ['amex', 'visa', 'mc', 'discover', 'diners', 'jcb'],
  'enable-reward-card-deactivation': true,
  'enable-account-in-footer': true,
  'enable-recent-items-add-to-cart': true,
  'enable-show-address2-before-city': false,
  enableRecentItemsWithModifiers: true,
  enableCustomBirthdayInput: true,
  'enable-feature-nutrition-integration': false,
  defaultServiceModeInStore: 'DISABLED',
  'enable-forced-native-app-update': 'none',
  enableHomePageRecentItems: true,
  enableAutoLocale: false,
  'phone-number-within-qrcode-widget': false,
  enablePromoCodeOffers: false,
  'payment-fields-variations': {
    zip: true,
    state: false,
    country: false,
    name: true,
    addressLine1: false,
    city: false,
    expiration: true,
    cardNumber: true,
    cvv: true,
    addressLine2: false,
  },
  'enable-fees-on-order-receipt': false,
  curbsideVehicleDescriptionMaxLength: 17,
  datadogLogSampleRate: 100,
  'enable-menu-upsell-items': true,
  'enable-lock-on-reward-image': true,
  'enable-redeem-in-restaurant-primary': false,
  enableMoreInfoOptionalOfferDisclaimer: true,
  'enable-signup-communications-preselection': false,
  'enable-fixed-add-to-order-and-quantity-button': true,
  'loyalty-in-restaurant-status-poll-interval-ms': 3000,
  singleRegionLanguageSelector: false,
  'enable-hide-tax-line': false,
  resetStoreResetCartTimeout: 0,
  'enable-edit-cart': true,
  'enable-in-restaurant-variations': { enableRewardRedemption: true, enableOfferRedemption: true },
  'force-restaurant-selection-for-rewards': true,
  'enable-tabbed-menu-bar-fav': true,
  enableCurbside: true,
  deliveryRadiusInMiles: 6,
  delivery: true,
  'enable-auto-link-rewards-card': false,
  'order-cart-version': 1,
  'enable-loyalty-offers': true,
  enableOrderSupport: true,
  enableThDirectPayGooglePay: false,
  enableCookieBanner: false,
  'discounted-delivery-threshold-cents': 1500,
  'enable-price-and-calories-in-menu': true,
  'enable-price-mismatch-internal-only': false,
  'sign-up-fields-variations': {
    email: true,
    dob: true,
    zip: false,
    country: false,
    phone: false,
    name: true,
    wantsPromotionalEmails: true,
    agreesToTermsOfService: true,
    gender: false,
  },
  'enable-signup-cart-button-text': false,
  'enable-forter-fraud': true,
  enableCatering: false,
  'enable-offers-static-page': false,
  checkoutDeliveryMinimumOverrideCents: 500,
  'enable-offers-edit-cart': false,
  nutritionEuDisplay: false,
  'enable-offer-redemption-methods': 'all',
  mobileCartUpsellLocation: 'aboveYourCart',
  enableRequestMyInformation: false,
  'enable-claim-loyalty-points': true,
  enableCognitoSignupInBe: true,
  'enable-plu-offer-qr-code': false,
  'enable-loyalty-offers-v2-fe': false,
  'enable-prepaid-payment-methods': {
    ONE_TIME_METHOD: true,
    GOOGLE_PAY: true,
    EXISTING_METHOD: true,
    CREDIT: true,
    APPLE_PAY: true,
  },
  enableSanityCdn: true,
  'enable-quest-tiles': true,
  'enable-loyalty-opt-in-modal': false,
  'enable-move-signup-after-cart': false,
  disableDineIn: false,
  'gift-card-payment-method': true,
  'enable-cooldown-toast-info': false,
  enableCookieVersioning: false,
  enableAllergensDisclaimer: false,
  'enable-main-fab-button': true,
  'enable-account-sections-variations': {
    submitFeedback: true,
    userPreferences: false,
    earnPoints: false,
    accountInfo: true,
    recentOrders: true,
    paymentMethods: true,
  },
  'enable-two-step-sign-up': false,
  'enable-foodware-items': false,
  enableLockedOffers: true,

  'max-rbi-api-retries': 5,
  'max-sanity-api-retries': 10,
  'enable-fast-lane-drive-thru': false,
  'enable-optional-amplitude-tracking': false,
  'enable-debug-menu': false,
};

// these flags seem to flow directly to GQL and aren't mentioned in the enum
const gatewayFlags = {
  'enable-gateway-createSupportCase': false,
  'enable-in-restaurant-loyalty': true,
  'enable-gateway-resendCurrentLoginOTP': true,
  'enable-gateway-exchangeOTPCodeForCognitoCredentials': true,
  'enable-gateway-evaluateAllUserOffers': true,
  'enable-gateway-userGeo': true,
  'enable-gateway-redeemCoupon': true,
  'enable-gateway-createLoginForVendor': true,
  'enable-gateway-evaluateUserOffers': true,
  'enable-gateway-gifts': false,
  'enable-gateway-signInJWT': true,
  'enable-gateway-listUserCouponTokens': true,
  'enable-gateway-deliveryRestaurant': false,
  'enable-gateway-resendVerificationEmail': true,
  'enable-gateway-createOTP': true,
  'enable-gateway-signUpComplete': true,
  'enable-gateway-signUp': true,
  'enable-gateway-requestMyInfo': false,
  'enable-gateway-restaurant': false,
  'enable-gateway-validateAuthJwt': true,
  'enable-gateway-restaurants': false,
  'enable-gateway-userFavorites': true,
  'enable-gateway-loyalty': false,
};

export default { ...safeFlagDefaults, ...gatewayFlags } as AllLaunchDarklyFlags;
